import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames/bind';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import makeQuery from 'yoda-core-components/lib/navigation/query/makeQuery';
import CAMNavLayout from 'yoda-site-components/lib/components/CAMNav/WithLayout';
import Icon from 'yoda-core-components/lib/components/Icon/Icon';
import MessageBox from 'yoda-core-components/lib/components/MessageBox/MessageBox';
import Warning from 'yoda-core-components/lib/assets/svg/Warning.svg';
import Loader from 'yoda-core-components/lib/components/Loader/Loader';
import CertonaZone from 'yoda-site-components/lib/components/CertonaZone/CertonaZone';
import SiteComponent from 'yoda-site-components/lib/components/SiteComponent/SiteComponent';
import User from 'yoda-site-components/lib/helpers/User/User';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import { Redirect } from 'react-router-dom';
import ListDetailsPanel from '../Lists/ListDetailsPanel/ListDetailsPanel';
import FilterPanel from '../../../components/Lists/FilterPanel/FilterPanel';
import TrendingListPanel from '../../../components/Lists/TrendingListPanel/TrendingListPanel';
import TrendListZone from '../../../components/TrendListZone/TrendListZone';
import { addQueryReplaceUrl, addQueryNewUrl } from '../../../common/UrlHelper';
import { listDuplicateListMessage } from '../../../common/Constants';
import * as styles from './TrendingList.css';

const cx = classNames.bind(styles);
class TrendingList extends SiteComponent {
    static defaultProps = {
        deviceType: {},
        myListsDetails: {},
        authStatus: true,
        featureFlag: {},
        messagesTexts: {},
        authenticationSuccess: false,
        firstName: '',
        isOOSListingEnabled: false,
        enableTrendingList: false,
    };

    static propTypes = {
        myListsDetails: PropTypes.objectOf(
            PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        ).isRequired,
        actions: PropTypes.objectOf.isRequired,
        location: PropTypes.shape({
            pathname: PropTypes.string.isRequired,
            basename: PropTypes.string.isRequired,
            query: PropTypes.objectOf(PropTypes.object).isRequired,
            search: PropTypes.string.isRequired,
        }).isRequired,
        router: PropTypes.objectOf.isRequired,
        featureFlag: PropTypes.objectOf.isRequired,
        messagesTexts: PropTypes.objectOf.isRequired,
        deviceType: PropTypes.shape({
            isMobile: PropTypes.bool.isRequired,
            isDesktop: PropTypes.bool.isRequired,
        }).isRequired,
        mountOnServer: PropTypes.bool.isRequired,
        preferences: PropTypes.objectOf.isRequired,
        headers: PropTypes.objectOf.isRequired,
        shareList: PropTypes.objectOf.isRequired,
        siteAccountAction: PropTypes.objectOf(PropTypes.object).isRequired,
        authenticationSuccess: PropTypes.bool,
        addToCart: PropTypes.objectOf(PropTypes.object).isRequired,
        draftOrder: PropTypes.objectOf(PropTypes.object).isRequired,
        firstName: PropTypes.string,
        isOOSListingEnabled: PropTypes.bool.isRequired,
        enableTrendingList: PropTypes.bool,
    };

    constructor(props) {
        super(props);
        this.state = {
            showTopMessage: false,
            message: '',
            type: '',
            authenticationSuccess: props.authenticationSuccess,
            atcSuccess: false,
        };
        this.openSlider = this.openSlider.bind(this);
        this.loadTrendingItem = this.loadTrendingItem.bind(this);
    }

    static getDerivedStateFromProps(props, state) {
        const { location } = props;
        const search = get(location, 'search', '');
        const query = makeQuery(search);
        const { id, token, accountId, trending } = query;
        let replaceUrlQuery;
        let nextUrlQuery;
        if (!id) {
            const firstData = get(props, 'myListsDetails.trendingListItems.listData[0]');
            if (firstData) {
                replaceUrlQuery = {
                    id: firstData.id,
                    token: firstData.shareToken,
                    accountId: firstData.accountId,
                    trending: true,
                };
            }
        } else {
            const { id: lid, token: ltoken, accountId: laccountId, trending: ltrending } = get(
                props,
                'myListsDetails.trendingItem.queryParams',
                {}
            );
            if (
                !(
                    id === lid &&
                    token === ltoken &&
                    accountId === laccountId &&
                    trending === ltrending
                )
            ) {
                nextUrlQuery = { id, token, accountId, trending };
            }
        }
        const { userState } = props;
        const userLoginStateChange = userState && userState !== state.userState;
        return {
            replaceUrlQuery,
            nextUrlQuery,
            userState,
            userLoginStateChange,
            authenticationSuccess: props.authenticationSuccess,
        };
    }

    componentDidMount() {
        const analyticsData = {
            trackEvent: 'digitalDataReady',
            pageName: 'list landing page',
        };
        const { location } = this.props;
        const search = get(location, 'search', '');
        const query = makeQuery(search) || {};
        const { id, cid } = query;
        this.props.actions.getLists(undefined, this.props.headers);
        let newId = id;
        if (cid !== 'custom_sharedlist') {
            newId = undefined;
        }
        this.props.actions.getTrendingLists(newId, this.props.headers);
        this.props.actions.myListAnalyticsAction(analyticsData);
    }

    componentDidUpdate(prevProps) {
        const { nextUrlQuery, replaceUrlQuery, userLoginStateChange, atcSuccess } = this.state;
        if (replaceUrlQuery) {
            addQueryReplaceUrl(replaceUrlQuery);
        } else if (nextUrlQuery) {
            const isLoading = get(
                this.props,
                'myListsDetails.trendingItem.isTrendingListItemsLoading'
            );
            !isLoading && this.props.actions.loadTrendingItems(nextUrlQuery, false);
        }
        if (userLoginStateChange) {
            this.props.actions.getLists();
        }
        if (
            prevProps.addToCart.isAddToCartSuccess !== this.props.addToCart.isAddToCartSuccess &&
            this.props.addToCart.isAddToCartSuccess &&
            !atcSuccess
        ) {
            this.setState({ atcSuccess: true });
        }
    }

    loadTrendingItem = (id, token, accountId) => {
        addQueryNewUrl({ id, token, accountId, cid: undefined });
    };

    isUserLoggedOn = () => {
        let isLoggedIn = false;
        /* istanbul ignore else */
        if (!__SERVER__) {
            isLoggedIn = User.isUserLoggedIn();
        } else {
            const userStateAtServer = get(this.props, 'headers.cookies.DP_USER_STATE', '0');
            isLoggedIn = userStateAtServer !== '0';
        }

        return isLoggedIn;
    };

    closeMessageBox = () => {
        this.setState({
            showMessage: false,
        });
    };

    closeSuccessMsg = () => {
        this.setState({
            showMessage: false,
        });
    };

    showTopMessage = (type, message, movedTo = '', movedId = '') => {
        this.setState({
            showMessage: true,
            message,
            type,
            movedTo,
            movedId,
        });
    };

    openSlider() {
        const { featureFlag, siteAccountAction } = this.props;
        /* istanbul ignore else */
        if (featureFlag.enableSignInSlider) {
            siteAccountAction.openSignInSlider();
        } else {
            window.location.assign('/signin?next=/mylist');
        }
    }

    showRecZone = () => {
        const slotType = 'listdetail_rr';
        return (
            <section className={cx('recContainer')}>
                <CertonaZone
                    page="LISTING"
                    slotDetails={{
                        pageType: 'WISHLIST',
                        attributes: {
                            schemes: `${slotType}`,
                            recommendations: true,
                        },
                        loader: 'certona',
                        slotId: `${slotType}`,
                        forceRefresh: true,
                    }}
                    schemasToRender={[`${slotType}`]}
                />
            </section>
        );
    };

    getListCategorySort = ({ sort, listId }) => {
        const { location } = this.props;
        const search = get(location, 'search', '');
        const query = makeQuery(search) || {};
        const { token, accountId, trending } = query;
        this.props.actions.loadTrendingItems(
            { id: listId, token, accountId, trending, sort },
            true
        );
    };

    showTrendListItemError = () => (
        <div className={cx('emptyList')}>
            <div className={cx('col12', 'mainSection')}>
                <center>
                    <Icon
                        pathClassName={cx('warningIconSv')}
                        className={cx('warningIconSvg')}
                        iconType="svg"
                        width="60px"
                        height="60px"
                        viewBox="0 0 60 60"
                    >
                        <Warning />
                    </Icon>
                </center>
                <p className={cx('sectionHeading')}>Oops! We lost something.</p>
                <p className={cx('sectionContent')}>
                    Looks like we had some trouble showing you this excellent collection of items.
                    Feel free to refresh the page or try again later!
                </p>
            </div>
        </div>
    );

    render() {
        const {
            myListsDetails,
            featureFlag,
            messagesTexts,
            preferences,
            savedListActions,
            shareList,
            authenticationSuccess,
            accounts,
            addToCart,
            addToCartActions,
            LoaderAction,
            mountOnServer,
            deviceType,
            MiniPDPActions,
            updatedItem,
            siteAccountAction,
            location,
            actions,
            headers,
            userState,
            firstName,
            isOOSListingEnabled,
            enableTrendingList,
        } = this.props;
        const { isTrendingLoading, trendingListItems, trendingItem } = myListsDetails;
        const loadingAutomationId = 'loadingAutomationId-1';
        const keepOverlay = true;
        const { showMessage, message, type, movedTo, movedId, atcSuccess } = this.state;
        const listData = get(trendingListItems, 'listData', []);
        const emptyData = isEmpty(listData);
        const trendingItemErr = trendingItem && 'error' in trendingItem;
        const typeInfoTheme = {
            privacyLabel: cx('privacyLabel'),
            curatedLabel: dt(['smMd:hidden', 'text-small', 'font-normal', 'mb-3']),
        };
        const search = get(location, 'search', '');
        const query = makeQuery(search);
        const curatorName = get(trendingItem, 'data.ownerName', '');
        if (!enableTrendingList) {
            return <Redirect to="/mylist" />;
        }
        return (
            <CAMNavLayout
                layoutState={{
                    title: userState !== '0' && firstName ? `Hi, ${firstName}!` : 'Trending List',
                }}
                classes={{
                    layoutHeaderClass: `${cx('md12')} ${dt(['smOnly:!mt-5'])}`,
                    panelContentContainer: cx('content-container', 'md12'),
                    root: cx('layout-container'),
                }}
                location={location}
                enableSignInSlider={featureFlag.enableSignInSlider}
                actions={siteAccountAction}
                renderRecZone={this.showRecZone}
            >
                {isTrendingLoading && (
                    <Loader automationId={loadingAutomationId} keepOverlay={keepOverlay} />
                )}
                {atcSuccess && (
                    <MessageBox
                        type="success"
                        title="Item has been moved to cart."
                        level="section"
                        automationId="list-notification-message"
                        onClose={() => {
                            this.setState({ atcSuccess: false });
                        }}
                    />
                )}

                {showMessage &&
                    !listDuplicateListMessage.includes(message) &&
                    message !== undefined && (
                        <MessageBox
                            type={type}
                            title={
                                <span>
                                    {`${message}`}{' '}
                                    {movedId && (
                                        <>
                                            <a
                                                className={dt(['!text-black', '!underline'])}
                                                href={`/mylist?id=${movedId}`}
                                            >
                                                {movedTo}
                                            </a>
                                            .
                                        </>
                                    )}
                                </span>
                            }
                            level="section"
                            automationId="list-notification-message"
                            onClose={this.closeMessageBox}
                        />
                    )}
                <section className={cx('listsContainer')}>
                    {!emptyData && (
                        <div className={cx('listSubContainer')}>
                            <TrendingListPanel
                                openSlider={this.openSlider}
                                showTopMessage={this.showTopMessage}
                                closeParentDialog={this.closeSuccessMsg}
                            />
                        </div>
                    )}
                    <TrendListZone
                        location={location}
                        loadTrendingItem={this.loadTrendingItem}
                        listData={listData}
                        deviceType={deviceType}
                    />
                    <section>
                        <FilterPanel
                            featureFlags={featureFlag}
                            actions={actions}
                            headers={headers}
                            myListsDetails={myListsDetails}
                            savedListActions={savedListActions}
                            shareList={shareList}
                            savedList={trendingItem}
                            location={location}
                            messagesTexts={messagesTexts}
                            openSlider={this.openSlider}
                            authenticationSuccess={authenticationSuccess}
                            preferences={preferences}
                            authStatus={this.isUserLoggedOn()}
                            getListCategorySort={this.getListCategorySort}
                            accounts={accounts}
                            showTopMessage={this.showTopMessage}
                            isShared
                            isTrending
                            deviceType={deviceType}
                            typeInfoTheme={typeInfoTheme}
                        />
                    </section>
                    {!trendingItemErr && (
                        <ListDetailsPanel
                            id={get(query, 'id', 'myFavorites')}
                            isLoggedIn={this.isUserLoggedOn()}
                            actions={{ ...actions, ...savedListActions }}
                            createList={actions.createList}
                            savedList={trendingItem}
                            addToCart={addToCart}
                            addToCartActions={addToCartActions}
                            LoaderAction={LoaderAction}
                            location={location}
                            headers={headers}
                            mountOnServer={mountOnServer}
                            deviceType={deviceType}
                            showTopMessage={this.showTopMessage}
                            MiniPDPActions={MiniPDPActions}
                            updatedItem={updatedItem}
                            openSlider={this.openSlider}
                            draftOrder={this.props.draftOrder}
                            isShared
                            isTrendingList="true"
                            isOOSListingEnabled={isOOSListingEnabled}
                            messagesTexts={messagesTexts}
                            enableMiniPDPFeature={featureFlag.enableMiniPDPFeature}
                        />
                    )}
                    {trendingItemErr && this.showTrendListItemError()}
                </section>
            </CAMNavLayout>
        );
    }
}

export default TrendingList;
